import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'

interface Step1BasicInfoProps {
  name: string
  description: string
  onNameChange: (value: string) => void
  onDescriptionChange: (value: string) => void
  errors: {
    name?: string
  }
}

const MAX_NAME_LENGTH = 100
const MAX_DESCRIPTION_LENGTH = 500

export function Step1BasicInfo({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  errors,
}: Step1BasicInfoProps) {
  return (
    <div className="space-y-6">
      {/* Name Field */}
      <div className="space-y-2">
        <Label htmlFor="name">
          Assistant Name <span className="text-destructive">*</span>
        </Label>
        <Input
          id="name"
          placeholder="e.g., Customer Support Bot"
          value={name}
          onChange={(e) => onNameChange(e.target.value.slice(0, MAX_NAME_LENGTH))}
          className={errors.name ? 'border-destructive' : ''}
        />
        <div className="flex justify-between text-xs">
          {errors.name ? (
            <span className="text-destructive">{errors.name}</span>
          ) : (
            <span className="text-muted-foreground">Required</span>
          )}
          <span className="text-muted-foreground">
            {name.length}/{MAX_NAME_LENGTH}
          </span>
        </div>
      </div>

      {/* Description Field */}
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          placeholder="Brief description of what this assistant does..."
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value.slice(0, MAX_DESCRIPTION_LENGTH))}
          rows={4}
        />
        <div className="flex justify-end text-xs text-muted-foreground">
          {description.length}/{MAX_DESCRIPTION_LENGTH}
        </div>
      </div>
    </div>
  )
}
